/* eslint-disable */

var legendDictionary = {
  pitch_type: {
    ALL: 'All Pitches',
    Fastball: 'Fastballs',  
    Offspeed: 'Offspeed',  
    Breaking: 'Breaking',  
    CHFS: 'Changeup',  
    CUKC: 'Curve',  
    SIFT: 'Sinker',      
    FF: 'Four Seamer',
    FT: 'Two Seamer',
    SI: 'Sinker',
    FC: 'Cutter',
    FA: 'Fastball',
    CH: 'Changeup',
    FS: 'Split Finger',
    SC: 'Screwball',
    FO: 'Forkball',
    SL: 'Slider',
    GY: 'Gyro',
    CU: 'Curve',
    KC: 'Knuckle Curve',
    KN: 'Knuckleball',
    EP: 'Eephus',
  },
  events: {
    single: 'Single',
    strikeout: 'Strikeout',
    double: 'Double',
    force_out: 'Force Out',
    sac_fly: 'Sac Fly',
    other_out: 'Other',
    pickoff_caught_stealing_2b: 'Pickoff 2B',
    called_strike: 'Called Strike',
    strikeout_triple_play: 'Strikeout Triple Play',
    defensive_substitution: 'Def. Sub',
    field_out: 'Field Out',
    home_run: 'Home Run',
    triple: 'Triple',
    field_error: 'Field Error',
    fielders_choice: 'Fielders Choice',
    triple_play: 'Triple Play',
    batter_interference: 'Batter Int',
    offensive_substitution: 'Off Sub',
    intent_ball: 'Intent Ball',
    walk: 'Walk',
    intent_walk: 'Intentional Walk',
    fielders_choice_out: 'Fielders Choice',
    sac_bunt: 'Sac Bunt',
    grounded_into_double_play: 'GIDP',
    strikeout_double_play: 'Strikeout DP',
    caught_stealing_home: 'Caught Stealing Home',
    pickoff_2b: 'Pickoff 2B',
    run: 'Run',
    pickoff_3b: 'Pickoff 3B',
    ball: 'Ball',
    umpire_substitution: 'Umpire Sub',
    stolen_base_3b: 'Stolen Base 3B',
    double_play: 'Double Play',
    other_advance: 'Other Adv',
    pitching_substitution: 'Pitching Sub',
    hit_by_pitch: 'Hit by Pitch',
    error: 'Error',
    catcher_interf: 'Catcher Int',
    pickoff_caught_stealing_3b: 'Pickoff 3B',
    at_bat_start: 'AB Start',
    caught_stealing_3b: 'Caught Stealing 3B',
    sac_fly_double_play: 'Sac Fly DP',
    swinging_strike: 'Swing & Miss',
    pickoff_caught_stealing_home: 'Pickoff Home',
    wild_pitch: 'Wild Pitch',
    caught_stealing_2b: 'Caught Stealing 2B',
    pickoff_1b: 'Pickoff 1B',
    stolen_base_2b: 'Stolen Base 2B',
    sac_bunt_double_play: 'Sac Bunt DP'
  },
  event_type: {
    foul_tip: 'Foul Tip',
    pitchout_hit_into_play_no_out: 'Hit Into Play - Pitchout',
    hit_by_pitch: 'Hit By Pitch',
    automatic_strike: 'Auto Strike',
    ball: 'Ball',
    missed_bunt: 'Missed Bunt',
    foul_pitchout: 'Foul Pitchout',
    swinging_pitchout: 'Swinging Pitchout',
    blocked_ball: 'Ball, Blocked',
    swinging_strike_blocked: 'Swing & Miss, Blocked',
    called_strike: 'Called Strike',
    bunt_foul_tip: 'Foul Tip - Bunt',
    automatic_ball: 'Auto Ball',
    foul: 'Foul',
    unknown_strike: 'Strike Unknown',
    pitchout_hit_into_play: 'Hit Into Play - Pitchout',
    foul_bunt: 'Foul Bunt',
    hit_into_play_score: 'Hit Into Play, Score',
    hit_into_play: 'Hit Into Play',
    swinging_strike: 'Swing & Miss',
    hit_into_play_no_out: 'Hit Into Play, No Out',
    pitchout: 'Pitchout',
    intent_ball: 'Intentional Ball',
    pitchout_hit_into_play_score: 'Hit Into Play, Pitchout'   
  },
  bb_type: {
    ground_ball: 'Ground Ball',
    line_drive: 'Line Drive',
    fly_ball: 'Fly Ball',
    popup: 'Popup'
    
  }
}
   
module.exports = { legendDictionary: legendDictionary };
